import {DateTime} from 'luxon'

export enum DayStatesEnum {
  DEFAULT = 'DEFAULT',
  DISABLED = 'DISABLED',
  SELECTED = 'SELECTED',
}

export type Slides = {day: DateTime; status: DayStatesEnum}[]
